import React, { useEffect, useRef, useState } from "react";
import { normalizeCheckoutConfig } from "../../utils/checkoutFormConfig";
import { formatCheckoutMoney } from "../../utils/formatPrice";
import CheckoutCartItem from "./CheckoutCartItem";

function OrderSummaryCheckout({
  cart,
  config,
  deliveryFee,
  totalDiscount,
  totalPriceDisplay,
  totalPriceHT,
  noCheckout,
  summaryDateLabel,
}) {
  const scrollContainerRef = useRef(null);
  const [atBottom, setAtBottom] = useState(false);
  const shouldApplyScroll = cart.length >= 9;

  useEffect(() => {
    if (!shouldApplyScroll) return;
    const handleScroll = () => {
      const container = scrollContainerRef.current;
      if (!container) return;
      const isAtBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight <
        5;
      setAtBottom(isAtBottom);
    };
    const container = scrollContainerRef.current;
    if (container) container.addEventListener("scroll", handleScroll);
    return () => {
      if (container) container.removeEventListener("scroll", handleScroll);
    };
  }, [shouldApplyScroll]);

  const taxVat = totalPriceDisplay - totalPriceHT;
  const cfg = normalizeCheckoutConfig(config);
  const showPartnerDiscount =
    cfg.showPartnerDiscountInSummary && totalDiscount > 0;
  const showDeliveryFee = cfg.showDeliveryFeeInSummary && deliveryFee > 0;
  const hasPricingExtras = showPartnerDiscount || showDeliveryFee;

  return (
    <div>
      <div className="os-box co-summary">
        <h3 className="os-title">Order Summary</h3>
        {summaryDateLabel ? (
          <div className="os-date">
            <span>📅</span>
            <span className="os-date-txt">{summaryDateLabel}</span>
          </div>
        ) : null}
        <div className="relative">
          <div
            className={
              cart.length >= 9 ? "overflow-y-scroll max-h-[288px]" : ""
            }
            ref={scrollContainerRef}
          >
            <div className="os-items">
              {cart.map((item) => (
                <CheckoutCartItem item={item} key={item.toy.id} />
              ))}
            </div>
          </div>

          {cart.length >= 9 && (
            <div
              className={`absolute bottom-0 left-0 w-full h-10 bg-gradient-to-t from-white to-transparent pointer-events-none transition-opacity duration-300 ${
                atBottom ? "opacity-0" : "opacity-100"
              }`}
            />
          )}
        </div>
        {hasPricingExtras ? (
          <>
            <div className="os-div" />
            {showPartnerDiscount ? (
              <div className="os-tax">
                <span>Partner Discount</span>
                <span className="pricing-discount-val">
                  −{formatCheckoutMoney(totalDiscount)} €
                </span>
              </div>
            ) : null}
            {showDeliveryFee ? (
              <div className="os-tax">
                <span>Delivery Fee</span>
                <span className="pricing-fee-val">
                  +{formatCheckoutMoney(deliveryFee)} €
                </span>
              </div>
            ) : null}
          </>
        ) : null}

        <div className="os-div" />
        <div className="os-total-row">
          <span className="os-total-lbl">Total to pay</span>
          <span className="os-total-price">
            {formatCheckoutMoney(totalPriceDisplay)} €
          </span>
        </div>
        <div className="os-tax">
          <span>Taxes (20% VAT)</span>
          <span>{formatCheckoutMoney(taxVat)} €</span>
        </div>
        <div className="os-tax">
          <span>Total excl. taxes</span>
          <span>{formatCheckoutMoney(totalPriceHT)} €</span>
        </div>
        <div className="os-notice">
          {noCheckout
            ? "Your order will be validated shortly."
            : "You will receive a confirmation email as soon as your payment is processed."}
        </div>
      </div>
    </div>
  );
}

export default OrderSummaryCheckout;
